// src/pages/tienda/Producto.js
import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useCart } from '../../context/CartContext';
import Breadcrumb from '../../components/Breadcrumb';
import ShareButtons from '../../components/ShareButtons';
import toast from 'react-hot-toast';
import '../../styles/producto.css';
import { track } from '../../utils/analytics';
import ReactPixel from 'react-facebook-pixel';


const CHAT_IMGS = [
  'https://res.cloudinary.com/drezxp44k/image/upload/v1777172626/chat_xaztmf.png',
  'https://res.cloudinary.com/drezxp44k/image/upload/v1777172626/chat2_ecrz02.png',
];
const WHATSAPP_NUM = '573113407979';
const StarDisplay = ({ n, size = 18 }) => (
  <span>
    {Array.from({ length: 5 }, (_, i) => (
      <span key={i} style={{ color: i < n ? '#e9c46a' : '#ddd', fontSize: size }}>★</span>
    ))}
  </span>
);
const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

export default function Producto() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [prod, setProd] = useState(null);
  const [resenas, setResenas] = useState([]);
  const [tab, setTab] = useState('desc');
  const [fotoActiva, setFotoActiva] = useState(0);
  const [resenaForm, setResenaForm] = useState({ nombre_cliente:'', calificacion:5, comentario:'' });
  const { agregar } = useCart();
  const [relacionados, setRelacionados] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatImg, setChatImg] = useState(0);
  const [msgs, setMsgs] = useState([{ rol:'bot', texto:'¡Hola! Soy el asistente de Wawita. ¿En qué te puedo ayudar hoy?' }]);
  const [msgInput, setMsgInput] = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const chatRef = useRef(null);

  useEffect(() => {
    api.get(`/productos/${id}`).then(r => {
      setProd(r.data);
    // SEO dinámico
    document.title = r.data.nombre + ' | Wawita Eco Friendly';
    document.querySelector('meta[name="description"]')?.setAttribute('content', r.data.descripcion_corta || r.data.descripcion || 'Producto natural Wawita');
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', r.data.nombre + ' | Wawita Eco Friendly');
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', r.data.descripcion_corta || r.data.descripcion || '');
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', r.data.imagen_principal || '');
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', 'https://wawita.co/producto/' + r.data.id);

      const p = r.data;
      const precioFinal = Number(p.descuento_activo) === 1 && Number(p.descuento_porcentaje) > 0
        ? Math.round(p.precio * (1 - p.descuento_porcentaje / 100))
        : p.precio;
      ReactPixel.track('ViewContent', {
        content_ids: [p.id],
        content_name: p.nombre,
        content_type: 'product',
        value: precioFinal,
        currency: 'COP',
      });
      track('view_product', { producto_id: p.id, producto_nombre: p.nombre, valor: precioFinal });
    }).catch(()=>{});
    api.get(`/resenas/producto/${id}`).then(r => setResenas(r.data)).catch(()=>{});
    api.get('/productos?limit=20').then(r => {
      const todos = r.data?.productos || r.data || [];
      const otros = todos.filter(p => p.id !== id);
      const shuffled = otros.sort(() => Math.random() - 0.5).slice(0, 4);
      setRelacionados(shuffled);
    }).catch(()=>{});
    setFotoActiva(0);
  }, [id]);


  const enviarChat = async () => {
    if (!msgInput.trim() || chatLoading) return;
    const userMsg = msgInput.trim();
    setMsgs(prev => [...prev, { rol:'user', texto: userMsg }]);
    setMsgInput('');
    setChatLoading(true);
    try {
      const r = await api.post('/ia/chat', { mensaje: userMsg, producto: prod?.nombre });
      setMsgs(prev => [...prev, { rol:'bot', texto: r.data?.respuesta || 'No entendí, intenta de nuevo.' }]);
    } catch {
      setMsgs(prev => [...prev, { rol:'bot', texto:'Hubo un error. ¡Escríbenos por WhatsApp!' }]);
    }
    setChatLoading(false);
  };
  const enviarResena = async () => {
    if (!resenaForm.comentario) return toast.error('Escribe un comentario');
    await api.post('/resenas', { producto_id: id, ...resenaForm });
    toast.success('Resena enviada, sera revisada pronto');
    setResenaForm({ nombre_cliente:'', calificacion:5, comentario:'' });
  };

  if (!prod) return <div style={{ padding:80, textAlign:'center' }}><div className="spinner" /></div>;

  const imagenesExtra = (() => { try { return JSON.parse(prod.imagenes || '[]'); } catch { return []; } })();
  const videos        = (() => { try { return JSON.parse(prod.videos || '[]'); } catch { return []; } })();

  const galeria = [
    ...(prod.imagen_principal ? [{ tipo:'imagen', url: prod.imagen_principal }] : []),
    ...imagenesExtra.map(url => ({ tipo:'imagen', url })),
    ...videos.map(url => ({ tipo:'video', url })),
  ];

  const total = galeria.length;
  const media = galeria[fotoActiva] || null;
  const anterior  = () => setFotoActiva(i => (i - 1 + total) % total);
  const siguiente = () => setFotoActiva(i => (i + 1) % total);

  const hasDiscount = Number(prod.descuento_activo) === 1 && Number(prod.descuento_porcentaje) > 0;
  const precioFinal = hasDiscount
    ? Math.round(prod.precio * (1 - prod.descuento_porcentaje / 100))
    : prod.precio;

  const stars = n => Array.from({length:5}, (_,i) => (
    <span key={i} style={{ color: i < n ? '#e9c46a' : '#ddd', fontSize:18 }}>★</span>
  ));

  const TABS = [
    ['desc',  'Descripcion'],
    ['ing',   'Ingredientes'],
    ['uso',   'Modo de uso'],
    ['res',   `Resenas (${resenas.length})`],
  ];

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label: prod.nombre }]} />

      <div className="producto-layout">
        <div className="producto-grid">

          {/* ── GALERIA ── */}
          <div>
            <div className="producto-galeria-principal">
              {!media && <div className="galeria-placeholder">🌿</div>}
              {media?.tipo === 'imagen' && <img src={media.url} alt={prod.nombre} />}
              {media?.tipo === 'video'  && <video src={media.url} controls style={{ width:'100%', height:'100%', objectFit:'cover', background:'#000' }} />}

              {total > 1 && <>
                <button className="galeria-nav-btn galeria-nav-prev" onClick={anterior}>&#8249;</button>
                <button className="galeria-nav-btn galeria-nav-next" onClick={siguiente}>&#8250;</button>
                <div className="galeria-contador">{fotoActiva + 1} / {total}</div>
              </>}
            </div>

            {total > 1 && (
              <div className="galeria-thumbs">
                {galeria.map((m, i) => (
                  <div key={i} className={`galeria-thumb ${fotoActiva===i?'activa':''}`} onClick={() => setFotoActiva(i)}>
                    {m.tipo === 'imagen'
                      ? <img src={m.url} alt={`foto ${i+1}`} />
                      : <div className="galeria-thumb-video">&#9654;</div>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* ── INFO ── */}
          <div className="producto-info">
            {prod.categoria_nombre ? <div className="producto-categoria">{prod.categoria_nombre}</div> : null}

            <h1 className="producto-nombre">{prod.nombre}</h1>

            {Number(prod.total_resenas) > 0 ? (
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}>
                <span>{stars(Math.round(Number(prod.calificacion_promedio)))}</span>
                <span style={{ fontSize:13, color:'#7a8a7a' }}>({prod.total_resenas} resenas)</span>
              </div>
            ) : null}

            {hasDiscount ? (
              <div className="producto-precio-descuento">
                <div className="precio-badge-descuento">
                  <span style={{ background:'#e76f51', color:'#fff', borderRadius:8, padding:'4px 12px', fontSize:14, fontWeight:900 }}>-{prod.descuento_porcentaje}% OFF</span>
                  <span className="precio-original">{fmtCOP(prod.precio)}</span>
                </div>
                <div className="precio-final">{fmtCOP(precioFinal)}</div>
                <div className="precio-ahorro">Ahorras {fmtCOP(prod.precio - precioFinal)}</div>
              </div>
            ) : (
              <div className="producto-precio-normal">{fmtCOP(prod.precio)}</div>
            )}

            {prod.descripcion_corta ? <p className="producto-descripcion">{prod.descripcion_corta}</p> : null}

            <div className="producto-botones">
              <button className="btn btn-primary" onClick={() => { agregar(prod); track('click_add_carrito', { producto_id: prod.id, producto_nombre: prod.nombre, valor: precioFinal }); toast.success(`${prod.nombre} agregado al carrito`); }}>
                Agregar al carrito
              </button>
              <button className="btn btn-dark" onClick={() => { agregar(prod); track('click_comprar_ahora', { producto_id: prod.id, producto_nombre: prod.nombre, valor: precioFinal }); navigate('/carrito'); }}>
                Ver carrito
              </button>
            </div>

            <div className="producto-badges">
              {['Natural','Eco','Sin crueldad','Colombia'].map(b => (
                <span key={b} className="producto-badge">{b}</span>
              ))}
            </div>

            {Number(prod.peso_gramos) > 0 ? (
              <div className="producto-meta">Contenido: <strong>{prod.peso_gramos}g</strong></div>
            ) : null}
            {prod.sku ? (
              <div className="producto-meta">SKU: <strong>{prod.sku}</strong></div>
            ) : null}
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="producto-tabs">
          {TABS.map(([key, lbl]) => (
            <button key={key} className={`producto-tab ${tab===key?'activa':''}`} onClick={() => setTab(key)}>
              {lbl}
            </button>
          ))}
        </div>

        <div className="card">
          <div className="card-body">
            {tab === 'desc' && <p style={{ lineHeight:1.8, color:'#5a6e5a' }}>{prod.descripcion || 'Sin descripcion disponible.'}</p>}
            {tab === 'ing'  && <p style={{ lineHeight:1.8, color:'#5a6e5a', whiteSpace:'pre-line' }}>{prod.ingredientes || 'Consulta con nosotros.'}</p>}
            {tab === 'uso'  && <p style={{ lineHeight:1.8, color:'#5a6e5a', whiteSpace:'pre-line' }}>{prod.modo_uso || 'Consulta con nosotros.'}</p>}
            {tab === 'res'  && (
              <div>
                {resenas.length === 0
                  ? <p style={{ color:'#7a8a7a', marginBottom:20 }}>Aun no hay resenas. Se el primero en opinar.</p>
                  : resenas.map(r => (
                    <div key={r.id} style={{ borderBottom:'1px solid rgba(44,94,46,0.08)', paddingBottom:16, marginBottom:16 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6, flexWrap:'wrap' }}>
                        <strong style={{ fontSize:14, color:'#1e401f' }}>{r.nombre_cliente}</strong>
                        <span>{stars(r.calificacion)}</span>
                        <span style={{ fontSize:11, color:'#8a9a8a' }}>{new Date(r.created_at).toLocaleDateString('es-CO')}</span>
                      </div>
                      <p style={{ fontSize:14, color:'#5a6e5a', lineHeight:1.6 }}>{r.comentario}</p>
                    </div>
                  ))
                }

                <div style={{ marginTop:24, background:'#f0f7ee', borderRadius:14, padding:20 }}>
                  <h3 style={{ fontFamily:'Playfair Display,serif', fontWeight:700, marginBottom:16, fontSize:17, color:'#1e401f' }}>Deja tu resena</h3>
                  <div className="form-group">
                    <label className="form-label">Tu nombre</label>
                    <input className="form-input" value={resenaForm.nombre_cliente} onChange={e=>setResenaForm(f=>({...f,nombre_cliente:e.target.value}))} placeholder="Maria Garcia" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Calificacion</label>
                    <div style={{ display:'flex', gap:4 }}>
                      {[1,2,3,4,5].map(n => (
                        <button key={n} onClick={() => setResenaForm(f=>({...f,calificacion:n}))} style={{ background:'none', border:'none', fontSize:32, cursor:'pointer', color: n<=resenaForm.calificacion?'#e9c46a':'#ddd', transition:'color 0.1s', padding:0 }}>★</button>
                      ))}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Comentario</label>
                    <textarea className="form-input" rows={3} value={resenaForm.comentario} onChange={e=>setResenaForm(f=>({...f,comentario:e.target.value}))} placeholder="Cuentanos tu experiencia con este producto..." style={{ resize:'vertical' }} />
                  </div>
                  <button className="btn btn-primary" onClick={enviarResena}>Enviar resena</button>
                </div>
              </div>
            )}

          {/* ══ SEGURIDAD ══ */}
          <section className="pdp-garantias">
            <div className="pdp-seguridad">
              <div className="pdp-seguridad-box">
                <div className="pdp-seg-titulo">🛡️ Compra 100% segura</div>
                <div className="pdp-seg-sub">Tus datos están protegidos.</div>
                <div className="pdp-pagos-logos">
                  <img className="pago-logo-img" src="/logos/visa.png" alt="Visa" />
                  <img className="pago-logo-img" src="/logos/mastercard.svg" alt="Mastercard" />
                  <img className="pago-logo-img" src="/logos/nequi.png" alt="Nequi" />
                  <img className="pago-logo-img" src="/logos/pse.png" alt="PSE" />
                  <img className="pago-logo-img" src="/logos/wompi.jpg" alt="Wompi" />
                </div>
              </div>
              <div className="pdp-compromiso">
                <div className="pdp-seg-titulo">❤️ Compromiso Wawita</div>
                <ul>
                  <li>✓ Ingredientes seguros y efectivos</li>
                  <li>✓ Hecho en Colombia con amor</li>
                  <li>✓ Cuidado para toda la familia</li>
                </ul>
              </div>
            </div>
          </section>
          {/* ══ RELACIONADOS ══ */}
          {relacionados.length > 0 && (
            <section className="pdp-relacionados">
              <h2>También te puede interesar</h2>
              <div className="pdp-rel-grid">
                {relacionados.map(p => {
                  const hd = Number(p.descuento_activo) === 1 && Number(p.descuento_porcentaje) > 0;
                  const pf = hd ? Math.round(p.precio * (1 - p.descuento_porcentaje / 100)) : p.precio;
                  return (
                    <div key={p.id} className="pdp-rel-card" onClick={() => navigate(`/producto/${p.id}`)}>
                      <div className="pdp-rel-img">
                        {p.imagen_principal
                          ? <img src={p.imagen_principal} alt={p.nombre} />
                          : <div className="pdp-rel-placeholder">🌿</div>}
                      </div>
                      <div className="pdp-rel-info">
                        <div className="pdp-rel-nombre">{p.nombre}</div>
                        <div className="pdp-rel-precio">{fmtCOP(pf)}</div>
                        {Number(p.calificacion_promedio) > 0 && (
                          <StarDisplay n={Math.round(Number(p.calificacion_promedio))} size={13} />
                        )}
                        <button className="pdp-rel-btn" onClick={e => { e.stopPropagation(); agregar(p); toast.success('Agregado'); }}>
                          🛒 Agregar
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}
          <ShareButtons url={'/producto/' + prod.id} titulo={prod.nombre} descripcion={prod.descripcion_corta} imagen={prod.imagen_principal} />
          </div>
        </div>
      </div>

      {/* ══ FABs — Chat + WhatsApp ══ */}
      <div style={{ position:'fixed', bottom:24, right:24, zIndex:200, display:'flex', flexDirection:'column', gap:12, alignItems:'center' }}>
        <a href={`https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent('Hola Wawita, tengo una pregunta sobre ' + (prod?.nombre || 'un producto'))}`}
          target="_blank" rel="noopener noreferrer"
          style={{ width:52, height:52, borderRadius:'50%', background:'#25D366', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 4px 16px rgba(37,211,102,0.4)', textDecoration:'none', fontSize:28 }}
          title="Escríbenos por WhatsApp">
          <img src="/logos/whatsapp.svg" alt="WhatsApp" style={{ width:30, height:30 }} />
        </a>
        {!chatOpen && (
          <button onClick={() => setChatOpen(true)}
            style={{ width:68, height:68, borderRadius:'50%', background:'transparent', border:'none', cursor:'pointer', padding:0, boxShadow:'0 6px 24px rgba(28,58,30,0.25)' }}
            title="Asistente Wawita">
            <img src={CHAT_IMGS[chatImg]} alt="Chat Wawita" style={{ width:'100%', height:'100%', borderRadius:'50%', objectFit:'cover' }} />
          </button>
        )}
      </div>
      {/* ══ CHAT IA ══ */}
      {chatOpen && (
        <div style={{ position:'fixed', bottom:28, right:28, width:340, background:'#FDFBF7', borderRadius:20, boxShadow:'0 12px 48px rgba(0,0,0,0.14)', zIndex:200, display:'flex', flexDirection:'column', maxHeight:520, overflow:'hidden', border:'1px solid rgba(159,190,106,0.2)' }}>
          <div style={{ background:'#9FBE6A', padding:'12px 16px', display:'flex', alignItems:'center', gap:12 }}>
            <img src={CHAT_IMGS[chatImg]} alt="Asistente" style={{ width:44, height:44, borderRadius:'50%', objectFit:'cover' }} />
            <div style={{ flex:1 }}>
              <div style={{ fontWeight:800, color:'#1C3A1E', fontSize:15 }}>Asistente Wawita</div>
              <div style={{ fontSize:12, color:'#2c5e2e' }}>Te ayudo con tus dudas</div>
            </div>
            <button onClick={() => setChatOpen(false)} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'#1C3A1E' }}>✕</button>
          </div>
          <div ref={chatRef} style={{ flex:1, overflowY:'auto', padding:16, display:'flex', flexDirection:'column', gap:10 }}>
            {msgs.map((m, i) => (
              <div key={i} style={{ display:'flex', justifyContent: m.rol==='user' ? 'flex-end' : 'flex-start' }}>
                <div style={{ maxWidth:'80%', padding:'10px 14px', borderRadius: m.rol==='user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px', background: m.rol==='user' ? '#9FBE6A' : '#f0f4e8', color: m.rol==='user' ? '#fff' : '#1C3A1E', fontSize:14, lineHeight:1.5 }}>
                  {m.texto}
                </div>
              </div>
            ))}
            {chatLoading && <div style={{ textAlign:'center', color:'#9FBE6A', fontSize:13 }}>Escribiendo...</div>}
          </div>
          <div style={{ padding:'10px 12px', borderTop:'1px solid rgba(159,190,106,0.2)', display:'flex', gap:8 }}>
            <input value={msgInput} onChange={e => setMsgInput(e.target.value)} onKeyDown={e => e.key==='Enter' && enviarChat()}
              placeholder="Escribe tu pregunta..." style={{ flex:1, border:'1px solid rgba(159,190,106,0.4)', borderRadius:10, padding:'8px 12px', fontSize:14, outline:'none', background:'#fafff6' }} />
            <button onClick={enviarChat} disabled={chatLoading} style={{ background:'#9FBE6A', color:'#1C3A1E', border:'none', borderRadius:10, padding:'0 16px', fontSize:18, cursor:'pointer', fontWeight:700 }}>↑</button>
          </div>
        </div>
      )}
    </div>
  );
}
